module.exports = __webpack_public_path__ + "img/courses.c70ce2e9.svg";